import React from 'react';

/** Section heading used for the editable worksheet fields — matches the
 * Claim Preview's uppercase muted section headers. */
export function EditSection({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section className='rounded-xl border border-slate-200 bg-white p-4 shadow-sm ring-1 ring-slate-100/70'>
      <h3 className='mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-slate-600'>
        <span className='h-1.5 w-1.5 rounded-full bg-teal-500' />
        {title}
      </h3>
      {children}
    </section>
  );
}
